module.exports = __webpack_public_path__ + "static/media/pr-comment.14c84328.png";